import React from 'react';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        var _a;
        const { children, onError, section } = this.props;
        const { componentId, resourceType } = ((_a = children === null || children === void 0 ? void 0 : children.props) === null || _a === void 0 ? void 0 : _a.model) || (children === null || children === void 0 ? void 0 : children.props);
        if (onError) {
            onError(error, {
                logger: 'ContentComponentLibrary | ErrorBoundary',
                section,
                extra: Object.assign({ componentId: componentId, resourceType: resourceType }, errorInfo),
            });
        }
        else {
            throw error;
        }
    }
    render() {
        const { hasError } = this.state;
        const { children, fallback } = this.props;
        if (hasError) {
            return fallback || null;
        }
        return children;
    }
}
export default ErrorBoundary;
//# sourceMappingURL=index.js.map